var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeedometer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m15.556 4.898-4.88 10.857c-.272.721-.817 1.12-1.35 1.12-.435 0-.812-.237-1.016-.628l-.001-.002c-.213-.445-.273-1.037-.007-1.512l5.922-10.594a.74.74 0 0 1 1.005-.299c.361.196.488.658.327 1.058M7.787 11.36a1.7 1.7 0 0 0 .582-.59l2.639-4.72a.276.276 0 0 0-.224-.413 10 10 0 0 0-.476-.012 9.69 9.69 0 0 0-9.248 6.794C.63 13.79 1.814 15 3.25 15c1.339 0 2.393-1.112 3.122-2.235a4.7 4.7 0 0 1 1.415-1.406m6.456 1.406a.33.33 0 0 1-.027-.311l1.972-4.388a.278.278 0 0 1 .434-.1 9.7 9.7 0 0 1 2.934 4.453C19.984 13.79 18.8 15 17.366 15c-1.34 0-2.394-1.112-3.123-2.235"
})));
SvgSpeedometer.displayName = "SvgSpeedometer";
export { SvgSpeedometer as ReactComponent };
export default SvgSpeedometer;